import React, { Component } from "react";
import {
  Button,
  Container,
  Row, Form,
  Col,
  Offcanvas,
} from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from '../config.json';
import { ValidationUtils } from '../Sidebar/Common';

import LoadingOverlay from "./LoadingOverlay";
export default class Permission_resources extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      touched: {}, // Track which fields have been touched
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.permission_resources_Id,
          sortable: true,
          cell: (row) => <span>{row.permission_resources_Id}</span>,
        },
        { name: "Module Name ", selector: (row, i) => row.module_name, sortable: true, cell: (row) => <span>{row.module_name}</span>, }, { name: "Resource Name", selector: (row, i) => row.resource_name, sortable: true, cell: (row) => <span>{row.resource_name}</span>, }, { name: "Resource Display Name", selector: (row, i) => row.resource_display_name, sortable: true, cell: (row) => <span>{row.resource_display_name}</span>, }, { name: "Resource Description", selector: (row, i) => row.resource_description, sortable: true, cell: (row) => <span>{row.resource_description}</span>, }, { name: "Table Name", selector: (row, i) => row.table_name, sortable: true, cell: (row) => <span>{row.table_name}</span>, }, { name: "Controller Name", selector: (row, i) => row.controller_name, sortable: true, cell: (row) => <span>{row.controller_name}</span>, }, { name: "Supports Ownership", selector: (row, i) => row.supports_ownership, sortable: true, cell: (row) => <span>{row.supports_ownership}</span>, }, { name: "Ownership Field", selector: (row, i) => row.ownership_field, sortable: true, cell: (row) => <span>{row.ownership_field}</span>, }, { name: "Company Field", selector: (row, i) => row.company_field, sortable: true, cell: (row) => <span>{row.company_field}</span>, }, { name: "Department Field", selector: (row, i) => row.department_field, sortable: true, cell: (row) => <span>{row.department_field}</span>, }, { name: "Sort Order", selector: (row, i) => row.sort_order, sortable: true, cell: (row) => <span>{row.sort_order}</span>, }, { name: "Status", selector: (row, i) => row.status, sortable: true, cell: (row) => <span>{row.status}</span>, },
        //***tableClms
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                style={{ marginRight: "10px" }}
                variant="primary"
                onClick={() => this.Permission_resourceseditHandler(row)}
                className="bi bi-pen"
              >
              </Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              >
              </Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      itemsPerPage: 10,
      isEditing: false,
      permission_resources_Id: "",
      module_name: '', resource_name: '', resource_display_name: '', resource_description: '', table_name: '', controller_name: '', supports_ownership: '', ownership_field: '', company_field: '', department_field: '', sort_order: '', statustypemaster: [], status: '',
      //***state
    };
  }

  // Enhanced validation method using Common.js with auto-generated logic
  validateField = (fieldName, value, fieldConfig) => {
    const { inputType, validationOptions } = fieldConfig;
    const fieldDisplayName = fieldConfig.displayName || fieldName;

    let validationResult = { isValid: true, message: "" };

    // Auto-generated validation based on inputType and validationOptions
    switch (inputType.toLowerCase()) {
      case 'text':
        if (validationOptions?.isName) {
          validationResult = ValidationUtils.validateName(value);
        } else if (validationOptions?.isAddress) {
          validationResult = ValidationUtils.validateAddress(value);
        } else if (validationOptions?.maxLength) {
          validationResult = ValidationUtils.validateLength(value, parseInt(validationOptions.maxLength), fieldDisplayName);
        } else {
          validationResult = { isValid: true, message: "" };
        }
        break;

      case 'mail':
      case 'email':
        validationResult = ValidationUtils.validateEmail(value);
        break;

      case 'telephone':
      case 'phone':
        validationResult = ValidationUtils.validatePhone(value);
        break;

      case 'number':
        validationResult = ValidationUtils.validateNumber(value, fieldDisplayName);
        break;

      case 'dob_child':
        validationResult = ValidationUtils.validateDOBMinAge(value);
        break;

      case 'dob_adult':
        validationResult = ValidationUtils.validateDOBAdult(value);
        break;

      case 'pan':
        validationResult = ValidationUtils.validatePAN(value);
        break;

      case 'aadhaar':
        validationResult = ValidationUtils.validateAadhaar(value);
        break;

      case 'password':
        if (value.length < 6) {
          validationResult = { isValid: false, message: "Password must be at least 6 characters long" };
        }
        break;

      default:
        validationResult = { isValid: true, message: "" };
    }

    // Check required field validation
    if (validationOptions?.isRequired && (!value || value.toString().trim() === "")) {
      validationResult = ValidationUtils.validateRequired(value, fieldDisplayName);
    }

    const errors = { ...this.state.errors };
    if (!validationResult.isValid) {
      errors[fieldName] = validationResult.message;
    } else {
      delete errors[fieldName];
    }

    this.setState({ errors });
    return validationResult.isValid;
  };

  // Enhanced field change handler with auto-validation
  handleFieldChange = (fieldName, value, fieldConfig) => {
    this.setState({
      [fieldName]: value,
      touched: { ...this.state.touched, [fieldName]: true }
    });

    // Only validate if field has been touched
    if (this.state.touched[fieldName] || value !== "") {
      this.validateField(fieldName, value, fieldConfig);
    }
  };

  // Enhanced field blur handler for validation
  handleFieldBlur = (fieldName, value, fieldConfig) => {
    this.setState({
      touched: { ...this.state.touched, [fieldName]: true }
    });
    this.validateField(fieldName, value, fieldConfig);
  };

  // Check if form is valid - auto-generated based on required fields
  isFormValid = () => {
    const { errors } = this.state;

    // Auto-generated required field validation
    // No required fields defined


    return Object.keys(errors).length === 0;
  };

  // Auto-generated validation for all fields before submission
  validateAllFields = () => {
    const fieldConfigs = [
      { fieldName: 'module_name', inputType: 'Text', displayName: 'Module Name ', validationOptions: { isRequired: false } },
      { fieldName: 'resource_name', inputType: 'Text', displayName: 'Resource Name', validationOptions: { isRequired: false } },
      { fieldName: 'resource_display_name', inputType: 'Text', displayName: 'Resource Display Name', validationOptions: { isRequired: false } },
      { fieldName: 'resource_description', inputType: 'Text', displayName: 'Resource Description', validationOptions: { isRequired: false } },
      { fieldName: 'table_name', inputType: 'Text', displayName: 'Table Name', validationOptions: { isRequired: false } },
      { fieldName: 'controller_name', inputType: 'Text', displayName: 'Controller Name', validationOptions: { isRequired: false } },
      { fieldName: 'supports_ownership', inputType: 'Number', displayName: 'Supports Ownership', validationOptions: { isRequired: false } },
      { fieldName: 'ownership_field', inputType: 'Text', displayName: 'Ownership Field', validationOptions: { isRequired: false } },
      { fieldName: 'company_field', inputType: 'Text', displayName: 'Company Field', validationOptions: { isRequired: false } },
      { fieldName: 'department_field', inputType: 'Text', displayName: 'Department Field', validationOptions: { isRequired: false } },
      { fieldName: 'sort_order', inputType: 'Number', displayName: 'Sort Order', validationOptions: { isRequired: false } },
      { fieldName: 'status', inputType: 'Select', displayName: 'Status', validationOptions: { isRequired: false } }
    ];

    fieldConfigs.forEach(config => {
      const value = this.state[config.fieldName];
      this.validateField(config.fieldName, value, config);
    });

    const touched = {};
    fieldConfigs.forEach(config => {
      touched[config.fieldName] = true;
    });
    this.setState({ touched });

  };

  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      errors: {},
      touched: {},
      module_name: '', resource_name: '', resource_display_name: '', resource_description: '', table_name: '', controller_name: '', supports_ownership: '', ownership_field: '', company_field: '', department_field: '', sort_order: '', statustypemaster: [], status: '',
    });
  };

  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({
      show: false,
      isEditing: false,
      errors: {},
      touched: {},
      module_name: '', resource_name: '', resource_display_name: '', resource_description: '', table_name: '', controller_name: '', supports_ownership: '', ownership_field: '', company_field: '', department_field: '', sort_order: '', statustypemaster: [], status: '',
    });
  };

  // Enhanced toast notifications
  showToast = (msg, type) => {
    switch (type) {
      case "success":
        toast.success(msg);
        break;
      case "error":
        toast.error(msg);
        break;
      case "warning":
        toast.warn(msg);
        break;
      default:
        toast.info(msg);
    }
  };

  Permission_resourceseditHandler = (row) => {
    this.setState({
      isEditing: true,
      show: true,
      permission_resources_Id: row.permission_resources_Id,
      module_name: row.module_name, resource_name: row.resource_name, resource_display_name: row.resource_display_name, resource_description: row.resource_description, table_name: row.table_name, controller_name: row.controller_name, supports_ownership: row.supports_ownership, ownership_field: row.ownership_field, company_field: row.company_field, department_field: row.department_field, sort_order: row.sort_order, statustypemaster: [], status: row.status,
      //***editstate
      errors: {},
      touched: {}
    });
  }

  Permission_resourcesfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);

    fetch(configData.api_url + 'C_Permission_resources/list', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      })
      .catch((error) => {
        console.error("Fetch error:", error);
        this.showToast("Failed to load data", "error");
      });
  }

  Permission_resourcessubmitHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before submitting", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append('module_name', this.state.module_name);
    formData.append('resource_name', this.state.resource_name);
    formData.append('resource_display_name', this.state.resource_display_name);
    formData.append('resource_description', this.state.resource_description);
    formData.append('table_name', this.state.table_name);
    formData.append('controller_name', this.state.controller_name);
    formData.append('supports_ownership', this.state.supports_ownership);
    formData.append('ownership_field', this.state.ownership_field);
    formData.append('company_field', this.state.company_field);
    formData.append('department_field', this.state.department_field);
    formData.append('sort_order', this.state.sort_order);
    formData.append('status', this.state.status);

    //***tableData*

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + 'C_Permission_resources/add', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Permission_resourcesfetchHandler();
          this.handleOffcanvasClose();
          this.setState({ module_name: '', resource_name: '', resource_display_name: '', resource_description: '', table_name: '', controller_name: '', supports_ownership: '', ownership_field: '', company_field: '', department_field: '', sort_order: '', statustypemaster: [], status: '', });
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Submit error:", error);
        this.showToast("Failed to save data", "error");
      
        this.setState({ loading: false });});
  }

  Permission_resourcesupdateHandler = (e) => {
    e.preventDefault();

    // Validate all fields before submission
    this.validateAllFields();

    if (!this.isFormValid()) {
      this.showToast("Please fix all errors before updating", "error");
      return;
    }

    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("permission_resources_Id", this.state.permission_resources_Id);
    formData.append('module_name', this.state.module_name);
    formData.append('resource_name', this.state.resource_name);
    formData.append('resource_display_name', this.state.resource_display_name);
    formData.append('resource_description', this.state.resource_description);
    formData.append('table_name', this.state.table_name);
    formData.append('controller_name', this.state.controller_name);
    formData.append('supports_ownership', this.state.supports_ownership);
    formData.append('ownership_field', this.state.ownership_field);
    formData.append('company_field', this.state.company_field);
    formData.append('department_field', this.state.department_field);
    formData.append('sort_order', this.state.sort_order);
    formData.append('status', this.state.status);

    //***tableData1

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + 'C_Permission_resources/update', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Permission_resourcesfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Update error:", error);
        this.showToast("Failed to update data", "error");
      
        this.setState({ loading: false });});
  }

  componentDidMount() {
    this.Permission_resourcesfetchHandler();
    this.statustypemasterfetchHandler();

    //***componentDidMount
  }

  handlemodule_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ module_name: fieldValue });
  }; handleresource_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ resource_name: fieldValue });
  }; handleresource_display_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ resource_display_name: fieldValue });
  }; handleresource_descriptionChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ resource_description: fieldValue });
  }; handletable_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ table_name: fieldValue });
  }; handlecontroller_nameChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ controller_name: fieldValue });
  }; handlesupports_ownershipChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ supports_ownership: fieldValue });
  }; handleownership_fieldChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ ownership_field: fieldValue });
  }; handlecompany_fieldChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ company_field: fieldValue });
  }; handledepartment_fieldChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ department_field: fieldValue });
  }; handlesort_orderChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ sort_order: fieldValue });
  }; handlestatusChange = (e) => {
    e.preventDefault();

    const fieldValue = e.target.value;
    this.setState({ status: fieldValue });
  }; statustypemasterfetchHandler = () => {
    fetch(configData.api_url + "C_Statustypemaster/list", {  // Enter your IP address here
      method: "POST",
      mode: "cors",
      body: {}// body data type must match "Content-Type" header
    }).then(response => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ statustypemaster: data.list });
        }
      });
  };
  //***inputFunctions

  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };

  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
  };

  handleDelete = (row, index) => {
    if (!window.confirm(`Are you sure you want to delete this permission_resources?`)) {
      return;
    }

    var formData = new FormData();
    formData.append('permission_resources_Id', row.permission_resources_Id);

    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + 'C_Permission_resources/delete', {
      method: 'POST',
      mode: 'cors',
      body: formData
    })
      .then(response => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.Permission_resourcesfetchHandler();
        }
      
        this.setState({ loading: false });})
      .catch((error) => {
        console.error("Delete error:", error);
        this.showToast("Failed to delete data", "error");
      
        this.setState({ loading: false });});
  };

  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  // Helper method to render error message
  renderFieldError = (fieldName) => {
    const { errors, touched } = this.state;
    if (errors[fieldName] && touched[fieldName]) {
      return (
        <div className="text-danger mt-1" style={{ fontSize: "0.875rem" }}>
          <i className="bi bi-exclamation-circle me-1"></i>
          {errors[fieldName]}
        </div>
      );
    }
    return null;
  };

  // Auto-generated form field renderer based on inputType and validation options
  renderFormField = (fieldConfig) => {
    const { fieldName, displayName, inputType, validationOptions } = fieldConfig;
    const value = this.state[fieldName] || "";
    const hasError = this.state.errors[fieldName] && this.state.touched[fieldName];

    let inputElement;

    switch (inputType.toLowerCase()) {
      case 'dob_child':
      case 'dob_adult':
      case 'date':
        inputElement = (
          <Form.Control
            type="date"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
          />
        );
        break;

      case 'telephone':
      case 'phone':
        inputElement = (
          <Form.Control
            type="tel"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter 10-digit mobile number"
          />
        );
        break;

      case 'mail':
      case 'email':
        inputElement = (
          <Form.Control
            type="email"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter email address"
          />
        );
        break;

      case 'password':
        inputElement = (
          <Form.Control
            type="password"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="Enter password"
          />
        );
        break;

      case 'number':
        inputElement = (
          <Form.Control
            type="number"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
          />
        );
        break;

      case 'pan':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.toUpperCase(), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="ABCPA1234B"
            maxLength="10"
          />
        );
        break;

      case 'aadhaar':
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value.replace(/\D/g, ''), fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder="123456789012"
            maxLength="12"
          />
        );
        break;

      default: // text and other types
        inputElement = (
          <Form.Control
            type="text"
            value={value}
            onChange={(e) => this.handleFieldChange(fieldName, e.target.value, fieldConfig)}
            onBlur={(e) => this.handleFieldBlur(fieldName, e.target.value, fieldConfig)}
            isInvalid={hasError}
            required={validationOptions?.isRequired}
            placeholder={`Enter ${displayName.toLowerCase()}`}
            maxLength={validationOptions?.maxLength || undefined}
          />
        );
    }

    return (
      <Row key={fieldName}>
        <Col lg="4" md="4">
          <Form.Label>
            {displayName}
            {validationOptions?.isRequired && <span className="text-danger">*</span>}
          </Form.Label>
        </Col>
        <Col lg="8" md="8">
          {inputElement}
          {this.renderFieldError(fieldName)}
        </Col>
      </Row>
    );
  };

  render() {
    const { errors, touched } = this.state;

    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <div>
                      <h3 className="logoskybluecolor" style={{ textAlign: "start" }}>Permission Resources</h3>
                    </div>
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary" style={{ float: "right", marginBottom: "10px" }}
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>

                      {/* Enhanced Add Offcanvas */}
                      <Offcanvas
                        show={this.state.show && !this.state.isEditing}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>Add Permission_resources</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container style={{ "overflowY": "auto", height: "auto" }}>

                            {/* Error Summary */}
                            {Object.keys(errors).length > 0 && (
                              <div className="alert alert-danger mb-3">
                                <strong>Please fix the following errors:</strong>
                                <ul className="mb-0 mt-2">
                                  {Object.entries(errors).map(([field, error]) => (
                                    <li key={field}>{error}</li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Module Name </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlemodule_nameChange} className="form-control" name="module_name" value={this.state.module_name} required="required" placeholder="Enter Module Name " />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.module_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Resource Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleresource_nameChange} className="form-control" name="resource_name" value={this.state.resource_name} required="required" placeholder="Enter Resource Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resource_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Resource Display Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleresource_display_nameChange} className="form-control" name="resource_display_name" value={this.state.resource_display_name} required="required" placeholder="Enter Resource Display Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resource_display_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Resource Description</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleresource_descriptionChange} className="form-control" name="resource_description" value={this.state.resource_description} required="required" placeholder="Enter Resource Description" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resource_description} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handletable_nameChange} className="form-control" name="table_name" value={this.state.table_name} required="required" placeholder="Enter Table Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Controller Name</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecontroller_nameChange} className="form-control" name="controller_name" value={this.state.controller_name} required="required" placeholder="Enter Controller Name" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.controller_name} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Supports Ownership</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlesupports_ownershipChange} className="form-control" name="supports_ownership" value={this.state.supports_ownership} required="required" placeholder="Enter Supports Ownership" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.supports_ownership} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Ownership Field</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handleownership_fieldChange} className="form-control" name="ownership_field" value={this.state.ownership_field} required="required" placeholder="Enter Ownership Field" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.ownership_field} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Company Field</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handlecompany_fieldChange} className="form-control" name="company_field" value={this.state.company_field} required="required" placeholder="Enter Company Field" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.company_field} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Department Field</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="text" onChange={this.handledepartment_fieldChange} className="form-control" name="department_field" value={this.state.department_field} required="required" placeholder="Enter Department Field" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.department_field} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Sort Order</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control type="number" onChange={this.handlesort_orderChange} className="form-control" name="sort_order" value={this.state.sort_order} required="required" placeholder="Enter Sort Order" />
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.sort_order} </div>
                                  </Row><br /><Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <select className="form-select" name="tableName" onChange={this.handlestatusChange}>
                                        <option defaultValue> Select Status </option>
                                        {this.state.statustypemaster.map((api, index, idx) => (
                                          <option key={index} value={api.active}> {api.active} </option>
                                        ))}
                                      </select>
                                    </Col>
                                    <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>
                                  </Row><br />
                                  {/* Auto-generated form content with validation */}
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={this.Permission_resourcessubmitHandler}
                                  disabled={!this.isFormValid()}
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>

                      {/* Enhanced Edit Offcanvas */}
                      {this.state.isEditing && (
                        <Offcanvas
                          show={this.state.isEditing}
                          onHide={this.handleOffcanvasClose}
                          {...this.props}
                          style={{ width: "500px" }}
                          placement="end"
                          backdrop="true"
                        >
                          <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit Permission_resources</Offcanvas.Title>
                          </Offcanvas.Header>
                          <Offcanvas.Body>
                            <Container style={{ "overflowY": "auto", height: "auto" }}>

                              {/* Error Summary */}
                              {Object.keys(errors).length > 0 && (
                                <div className="alert alert-danger mb-3">
                                  <strong>Please fix the following errors:</strong>
                                  <ul className="mb-0 mt-2">
                                    {Object.entries(errors).map(([field, error]) => (
                                      <li key={field}>{error}</li>
                                    ))}
                                  </ul>
                                </div>
                              )}

                              <Row className="divstyle">
                                <Row>
                                  <Form>
                                    <Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Module Name </Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlemodule_nameChange} className="form-control" name="module_name" value={this.state.module_name} required="required" placeholder="Enter Module Name " />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.module_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Resource Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleresource_nameChange} className="form-control" name="resource_name" value={this.state.resource_name} required="required" placeholder="Enter Resource Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resource_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Resource Display Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleresource_display_nameChange} className="form-control" name="resource_display_name" value={this.state.resource_display_name} required="required" placeholder="Enter Resource Display Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resource_display_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Resource Description</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleresource_descriptionChange} className="form-control" name="resource_description" value={this.state.resource_description} required="required" placeholder="Enter Resource Description" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.resource_description} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Table Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handletable_nameChange} className="form-control" name="table_name" value={this.state.table_name} required="required" placeholder="Enter Table Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.table_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Controller Name</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecontroller_nameChange} className="form-control" name="controller_name" value={this.state.controller_name} required="required" placeholder="Enter Controller Name" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.controller_name} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Supports Ownership</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlesupports_ownershipChange} className="form-control" name="supports_ownership" value={this.state.supports_ownership} required="required" placeholder="Enter Supports Ownership" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.supports_ownership} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Ownership Field</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handleownership_fieldChange} className="form-control" name="ownership_field" value={this.state.ownership_field} required="required" placeholder="Enter Ownership Field" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.ownership_field} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Company Field</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handlecompany_fieldChange} className="form-control" name="company_field" value={this.state.company_field} required="required" placeholder="Enter Company Field" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.company_field} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Department Field</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="text" onChange={this.handledepartment_fieldChange} className="form-control" name="department_field" value={this.state.department_field} required="required" placeholder="Enter Department Field" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.department_field} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Sort Order</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <Form.Control type="number" onChange={this.handlesort_orderChange} className="form-control" name="sort_order" value={this.state.sort_order} required="required" placeholder="Enter Sort Order" />
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.sort_order} </div>
                                    </Row><br /><Row>
                                      <Col lg="4" md="4">
                                        <Form.Label style={{ paddingTop: "8px" }}>Status</Form.Label>
                                      </Col>
                                      <Col lg="8" md="8">
                                        <select className="form-select" name="tableName" onChange={this.handlestatusChange}>
                                          <option defaultValue> Select Status </option>
                                          {this.state.statustypemaster.map((api, index, idx) => (
                                            <option key={index} value={api.active}> {api.active} </option>
                                          ))}
                                        </select>
                                      </Col>
                                      <div className="errorMsg" style={{ color: "red" }}> {this.state.errors.status} </div>
                                    </Row><br />
                                    {/* Auto-generated form content with validation */}
                                  </Form>
                                </Row>
                              </Row>
                              <Row>
                                <Col
                                  className="d-flex justify-content-end"
                                  style={{ marginRight: "50px" }}
                                >
                                  <Button
                                    className="button"
                                    variant="success"
                                    onClick={this.Permission_resourcesupdateHandler}
                                    disabled={!this.isFormValid()}
                                    style={{
                                      marginTop: "20px",
                                    }}
                                  >
                                    Update
                                  </Button>
                                </Col>
                              </Row>
                            </Container>
                          </Offcanvas.Body>
                        </Offcanvas>
                      )}
                      {/*offcanvas is over */}
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ "marginRight": "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    );
  }
}